import DrAvatar from './lib/components/DrAvatar';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const CoveredServicePage = ({ estimate }) => {
  const coverageActive = estimate?.coverageActive;

  return (
    <div className="flex flex-col gap-5 rounded-2xl bg-[#E8F6FC] p-6">
      <SlideHeader title="Coverage" />

      <div className="flex items-start gap-4 sm:flex-col sm:items-center">
        <DrAvatar size="medium" variant={1} />
        <SpeechBubble variant="default">
          {coverageActive
            ? "Good news — based on what we got back from your insurance, today's services are covered by your plan. Your insurance will start sharing the cost once you meet your remaining deductible."
            : "We don't have active insurance coverage on file for today's visit, so the amounts below reflect what you'd pay directly. If you have insurance, share it with our front desk and we'll re-estimate."}
        </SpeechBubble>
      </div>
    </div>
  );
};

export default CoveredServicePage;
